import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Linking } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { supportStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'

import { Colors } from '../../util/util'
import { styles } from './styles'

const ContactUs: FC = ({ path }: any) => {
  const openMailClient = () => {
    Linking.openURL(`mailto:${supportStrings.emailId}`)
  }

  // const openPhoneNumber = () => {
  //   const phoneNumber = supportStrings.supportNumber
  //   Linking.openURL(`tel:${phoneNumber}`)
  // }

  const suportCenterInfo = (text: string, val: string, func: () => any) => {
    return (
      <>
        <Box pt={30} underlayColor="WHITE">
          <Text type={'body2'} color={Colors.BLACK_21 as ColorOptions}>
            {text}
          </Text>
        </Box>
        <Box pt={16} underlayColor="WHITE" onPress={func} testID='contact-us-mailid'>
          <Text type={'body2'} color={Colors.PRIMARY as ColorOptions}>
            {val}
          </Text>
        </Box>
      </>
    )
  }

  return (
    <>
      <Box {...styles.container}>
        <Text type={'h1'} testID="page-title">{path === Routes.SUPPORT ? supportStrings.title : supportStrings.contactUs}</Text>
        <Box {...styles.border} />
        <Box justify="center" f={0.9} alignItems="center">
          <SvgImage imageName={'Support'} />
          {suportCenterInfo(supportStrings.emailUs, supportStrings.emailId, openMailClient)}
          {/* {suportCenterInfo(supportStrings.contactSupport, supportStrings.supportNumber, openPhoneNumber)} */}
        </Box>
      </Box>
    </>
  )
}
export default ContactUs
